import * as constAction from 'root/actionConstants';

export const getByDoc = (documento, i) => ({
  type: constAction.USUARIOS_CASUALES_GET_BY_DOCUMENTO,
  payload: {documento},
  epic: {
    url: 'usuarios/getUsuarioByDoc',
    method: 'GET',
  },
  state: {i},
});

export const setByDocState = (result, i) => ({
  type: constAction.USUARIOS_CASUALES_SET_STATE_BY_DOCUMENTO,
  payload: {
    result, i
  },
});

export const add = data => ({
  type: constAction.USUARIOS_CASUALES_ADD_STATE,
  payload: data,
});

export const delete_ = index => ({
  type: constAction.USUARIOS_CASUALES_REMOVE_STATE,
  payload: {index},
});

export const resetState = () => ({
  type: constAction.USUARIOS_CASUALES_RESET_STATE,
});



// WEBPACK FOOTER //
// src/modules/usuariosCasuales/action.js